import { apiFetch } from "@core/http";
import type { Offer, OfferInput } from "@core/types";

export type { OfferInput } from "@core/types";

const base = "/v1/portal/offers";

export interface OfferFilter {
  active?: boolean;
  categoryId?: string;
}

export const listOffers = (filter: OfferFilter = {}) => {
  const params = new URLSearchParams();
  if (filter.active !== undefined) params.set("active", String(filter.active));
  if (filter.categoryId) params.set("categoryId", filter.categoryId);
  const suffix = params.size ? `?${params}` : "";
  return apiFetch<Offer[]>(`${base}${suffix}`);
};

// PA-037-D (agent-logs/runs/2026-09-11-visual-contract-authority-only/
// evidence/human-resolution-pa-037.json): a diferencia de Beneficios y
// Recompensas, acá `code` lo escribe quien crea la oferta — el dominio no lo
// genera. El formulario lo envía siempre, en alta y en edición, porque
// `OfferInput` lo exige en ambos verbos del contrato publicado; el servicio
// lo descarta en `update` conservando el persistido.
export const createOffer = (input: OfferInput) =>
  apiFetch<Offer>(base, { method: "POST", body: input });

export const editOffer = (id: string, input: OfferInput) =>
  apiFetch<Offer>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// SPEC-219 §5/§9/§10 criterios 5 y 6: DELETE inactiva, nunca borra. La
// primera llamada no manda `confirmed` (equivale a `false`): si hay
// promociones enlazadas o solicitudes abiertas, el servidor responde 409
// (`OFFER_LINKED`/`OFFER_HAS_REQUESTS`) con el conteo en `problem.impact`
// (`{ linkedPromotions, openRequests }`) y la pantalla reintenta con
// `confirmed: true` tras la confirmación del operador. Mismo patrón que
// `inactivateProfile` (profiles/api.ts).
export const inactivateOffer = (id: string, confirmed: boolean) =>
  apiFetch<void>(
    `${base}/${encodeURIComponent(id)}${confirmed ? "?confirmed=true" : ""}`,
    { method: "DELETE" },
  );
